export default __webpack_public_path__ + "static/media/BannerMultiCapNfo.96664f08.png";